import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { user } = useAuth();
  const location = useLocation();
  
  // Check if user is in dashboard
  const isInDashboard = location.pathname.startsWith('/dashboard');
  
  // If user is logged in and in dashboard, don't show footer
  if (user && isInDashboard) {
    return null;
  }
  
  const footerLinks = {
    product: [
      { label: 'Features', path: '/features' },
      { label: 'Pricing', path: '/pricing' },
      { label: 'Case Studies', path: '/case-studies' }
    ],
    resources: [
      { label: 'Blog', path: '/blog' },
      { label: 'Help Center', path: '/help' },
      { label: 'Guides', path: '/guides' },
      { label: 'Webinars', path: '/webinars' }
    ],
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Careers', path: '/careers' },
      { label: 'Contact', path: '/contact' },
      { label: 'Partners', path: '/auth/partners' }
    ],
    legal: [
      { label: 'Cookie Policy', path: '/cookies' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Company info */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <img 
                src="/output-onlinepngtools.png" 
                alt="AdvisorGrow Logo" 
                width="847"
                height="181"
                className="h-auto w-auto max-h-16"
                style={{ 
                  aspectRatio: '847/181',
                  maxWidth: '100%'
                }}
              />
            </Link>
            <p className="text-gray-400 mb-2 max-w-md">
              The all-in-one marketing platform designed specifically for financial advisors to attract, convert, and retain high-value clients.
            </p>
            <p className="text-gray-500 text-sm mb-6 max-w-md">
              For Financial Professional Use Only. Not for use for the general public.
            </p>
          </div>

          {/* Links sections */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="hover:text-secondary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="hover:text-secondary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="hover:text-secondary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            &copy; {currentYear} AdvisorGrow. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex flex-wrap space-x-5 text-sm">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="text-gray-600 hover:text-gray-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;